var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6725,
    cy: 17.549,
    rx: 17.6725,
    ry: 17.549,
    fill: "url(#paint0_radial)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8464 5.91772L17.6917 6.43055V21.3116L17.8464 21.4623L24.9309 17.3792L17.8464 5.91772Z",
    fill: "white",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8465 5.91772L10.762 17.3792L17.8465 21.4623V14.2395V5.91772Z",
    fill: "white",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8465 22.7702L17.7593 22.8739V28.1749L17.8465 28.4232L24.9353 18.6892L17.8465 22.7702Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8465 28.4231V22.7701L10.762 18.6891L17.8465 28.4231Z",
    fill: "white",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8464 21.4622L24.9309 17.3792L17.8464 14.2395V21.4622Z",
    fill: "white",
    fillOpacity: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.762 17.3791L17.8464 21.4622V14.2394L10.762 17.3791Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7772) rotate(91.8025) scale(35.1156 35.3624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4477FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB74FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1733,
    height: 22.5105,
    fill: "white",
    transform: "translate(10.762 5.91772)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8dea81f43ea98fe7fccef8ee4a88215c.svg";
export { ForwardRef as ReactComponent };